import type { AnalyticsEventPayload, UIAnalyticsEvent } from '@atlaskit/analytics-next';

type Attributes = Record<string, unknown>;

export const fireErrorAnalytics = (
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent,
	reason: string,
	attributes?: Attributes,
) => {
	createAnalyticsEvent({
		type: 'sendOperationalEvent',
		data: {
			source: 'confluence',
			action: 'error',
			actionSubject: 'experiment',
			attributes: {
				reason,
				experimentKey: 'jsw_confluence_day_0_auto_provision',
				...attributes,
			},
		},
	}).fire();
};

export const fireSuccessAnalytics = (
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent,
	action: string,
	actionSubject: string,
	attributes?: Attributes,
) => {
	createAnalyticsEvent({
		type: 'sendTrackEvent',
		data: {
			source: 'confluence',
			action: 'succeeded',
			actionSubject: 'dataFetchStep',
			attributes: {
				experimentKey: 'jsw_confluence_day_0_auto_provision',
				step: actionSubject + action,
				...attributes,
			},
		},
	}).fire();
};
